import { Navigate } from "react-router-dom";
import { Settings } from "@/routes/Settings";
import { Runs } from "@/routes/Runs";
import { PublicCity } from "@/routes/public-city";
import { Onboarding } from "@/routes/Onboarding";
import { Home } from "@/routes/Home";
import { City } from "@/routes/City";
import { Login } from "@/routes/auth/Login";
import { Join } from "@/routes/auth/Join";

export const unauthenticatedRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/join",
    element: <Join />,
  },
  {
    path: "/join/:code",
    element: <Join />,
  },
  {
    path: "/:username/:city",
    element: <PublicCity />,
  },
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
];

export const authenticatedRoutes = [
  { path: "/home", element: <Home /> },
  { path: "/onboarding", element: <Onboarding /> },
  { path: "/city/:city", element: <City /> },
  { path: "/runs", element: <Runs /> },
  { path: "/settings", element: <Settings /> },
  { path: "/:username/:city", element: <PublicCity /> },
  { path: "/", element: <Navigate to="/home" replace /> },
  // Anything else (including /login right after auth flips) lands on home.
  { path: "*", element: <Navigate to="/home" replace /> },
];

const routes = [...unauthenticatedRoutes, ...authenticatedRoutes];

export default routes;
